module.exports = __webpack_public_path__ + "static/media/Mobile_Carrosel_API_GATEWAY.4d5c6c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/APIGATEWAY/Mobile_Carrosel_API_GATEWAY.png
// module id = 198
// module chunks = 0